var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.isFriend = !_vm.isFriend}}},[_vm._v(_vm._s(_vm.isFriend ? _vm.friendTime : _vm.time))])
}
var staticRenderFns = []

export { render, staticRenderFns }